import { Heading, Box, Text, Grid, Link, Center, List, ListItem, ListIcon, OrderedList, UnorderedList} from "@chakra-ui/react";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import Capture from "assets/img/Capture.PNG";
import React from "react";

const AboutToolItem = ({title, link}) => {
  return (
    <Card>
      <CardHeader>
        <Link href={link}><Heading as='h3' size='lg'>{title}</Heading></Link>
      </CardHeader>
      <CardBody mt="30px">
        <Grid
            gap='24px'
            mb={{ lg: "26px" }}>
            <Box fontSize="15px">
                <Text>To be updated</Text>
            </Box>
        </Grid>
      </CardBody>
    </Card>
    
  );
};

export default AboutToolItem;